/**
 * @type {{data: null | RoiCalculatorFormData}}
 */
let calculatorDataStore = { data: null };

module.exports = calculatorDataStore;